import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';
import { ArrowTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/ArrowTone';

interface DiagramArrowProps {
  d: string;
  tone?: ArrowTone;
  dashed?: boolean;
}

export const DiagramArrow = ({ d, tone = ArrowTone.LINE, dashed = false }: DiagramArrowProps) => {
  const { colors, markerId } = useDiagramContext();

  return (
    <path
      d={d}
      fill="none"
      stroke={colors.arrow[tone]}
      strokeWidth={1.6}
      strokeDasharray={dashed ? '4 4' : undefined}
      markerEnd={`url(#${markerId}-${tone})`}
    />
  );
};
